
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 3.667A8.336 8.336 0 003.665 12c0 4.6 3.733 8.333 8.333 8.333S20.333 16.6 20.333 12s-3.734-8.333-8.334-8.333zM9.74 15.575l-2.992-2.992a.83.83 0 111.175-1.175l2.409 2.4 5.733-5.733a.83.83 0 111.175 1.175l-6.325 6.325a.83.83 0 01-1.175 0z"}})])
          )
        }
      }
    